import { DropDownButton } from 'components';
import { AdjustmentType } from 'enums';
import { getAdjustmentCategoryTitle }  from 'functions';
import styles from './AdjustmentTypeFilter.module.scss';

interface Props {
    adjustmentType?: number,
    onAdjusmentTypeChange: (value?: number) => void
}

const options = [
    {
        id: undefined,
        text: 'All'
    },
    {
        id: AdjustmentType.CustomerDedRepay,
        text: getAdjustmentCategoryTitle(AdjustmentType.CustomerDedRepay)
    },
    {
        id: AdjustmentType.CustomerDeduction,
        text: getAdjustmentCategoryTitle(AdjustmentType.CustomerDeduction)
    },
    {
        id: AdjustmentType.Discount,
        text: getAdjustmentCategoryTitle(AdjustmentType.Discount)
    },
    {
        id: AdjustmentType.DotBillback,
        text: getAdjustmentCategoryTitle(AdjustmentType.DotBillback)
    },
    {
        id: AdjustmentType.DotCreditToSupplier,
        text: getAdjustmentCategoryTitle(AdjustmentType.DotCreditToSupplier)
    },
    {
        id: AdjustmentType.Pricing,
        text: getAdjustmentCategoryTitle(AdjustmentType.Pricing)
    },
    {
        id: AdjustmentType.Quantity,
        text: getAdjustmentCategoryTitle(AdjustmentType.Quantity)
    },
    {
        id: AdjustmentType.SpecialPricing,
        text: getAdjustmentCategoryTitle(AdjustmentType.SpecialPricing)
    },
]

export const AdjustmentTypeFilter = ({adjustmentType, onAdjusmentTypeChange} : Props) =>  {
    const selectedLabel = options.find(option => option.id === adjustmentType)?.text;
    const label = selectedLabel === 'All'
        ? 'Adjustment Type: All'
        : selectedLabel;

    return (
        <DropDownButton 
            className={styles.control}
            items={options}
            text={label}
            onItemClick={(e) => onAdjusmentTypeChange(e.item.id ?? undefined)}
        />
    )
};
